import { Subject } from 'rxjs'
import { Injectable } from '@angular/core'

export type KeyValue = { key: string; value: any }

@Injectable({ providedIn: 'platform' })
export class BaseStorageService {
  private subjectMap: Map<string, Subject<KeyValue>> = new Map()

  get(key: string) {
    return localStorage.getItem(key)
  }

  set(key: string, value: string) {
    localStorage.setItem(key, value)
    this.observe(key, { key, value })
  }

  subscribe(key: string, sub: (next: KeyValue) => {}) {
    let subject = this.subjectMap.get(key)

    if (!subject) {
      subject = new Subject()
      this.subjectMap.set(key, subject)
    }

    return subject.subscribe(sub)
  }

  observe(key: string, value: KeyValue) {
    this.subjectMap.get(key)?.next(value)
  }
}
